export default "__VITE_ASSET__nejkbdvt__"